import { render, staticRenderFns } from "./coderProCodingFindings.vue?vue&type=template&id=353b03f3&scoped=true&"
import script from "./coderProCodingFindings.vue?vue&type=script&lang=js&"
export * from "./coderProCodingFindings.vue?vue&type=script&lang=js&"
import style0 from "./coderProCodingFindings.vue?vue&type=style&index=0&id=353b03f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b03f3",
  null
  
)

export default component.exports